export default "__VITE_ASSET__CqRsGA5F__"